import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  link: {
    '&:hover': {
      color: theme.palette.primary.dark,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
    color: theme.palette.primary.main,
    fontWeight: 500,
    textDecoration: 'underline',
    transition: `color ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
  },
}))

export default useStyles
